import formatDate from '../helpers/formatDate';
import formatServiceMinutes from '../helpers/formatServiceMinutes';

export default ({ contactDetails, date, time, servicesText, servicesTime }) => `
	<form action="#!" class="modal__form modal-form" method="post">
		<div class="modal-form__top">
			<div class="modal-form__left">
				<label class="modal-form__label" for="name">
					<span class="modal-form__name">Имя</span>
					<input 
						data-rm-name-input
						class="modal-form__input modal-form__input--name" 
						id="name" 
						maxlength="40" 
						name="name" 
						placeholder="Например: Иванов Иван Иванович" 
						type="text"
						value="${contactDetails.name !== null ? contactDetails.name : ''}"
					>
				</label>
				<label class="modal-form__label" for="phone">
					<span class="modal-form__phone">Телефон</span>
					<input 
						data-rm-phone-input
						class="modal-form__input modal-form__input--phone"
						id="phone"
						name="phone"
						placeholder="+7 (___) ___ - __ - __"
						type="text"
						value="${contactDetails.phone !== null ? contactDetails.phone : ''}">
				</label>
			</div>
			<div class="modal-form__right">
				<span class="modal-form__comments">Комментарий</span>
				<textarea
					data-rm-comment-input
					class="modal-form__textarea" 
					name="comment" 
				>${contactDetails.comment !== null ? contactDetails.comment : ''}</textarea>
			</div>
		</div>
		<div class="modal-form__bottom">
			<div class="modal-form__info">
				<ul class="modal-form__list">
					<li class="modal-form__item">
					Вы будете записаны на:
					 <span class="modal__time--green">${formatDate(date)}</span> г. на
					 <span class="modal__time--green">${time}</span></li>
					<li class="modal-form__item">
						Услуга: <span class="modal__time--green">${servicesText}</span>
					</li>
					<li class="modal-form__item">Время: <span class="modal__time--green">${formatServiceMinutes(servicesTime)}</span></li>
				</ul>
			</div>
		</div>
	</form>
`;
